export default __webpack_public_path__ + "static/media/bullet-applypattern.320ed783.gif";